import request from './request';

export function signIn(payload: { email: string; password: string }) {
  return request.post('/auth/sign_in', payload);
}

export function oauthSignIn(payload: { provider: string; code: string }) {
  return request.post('auth/oauth', payload);
}

export async function logout() {
  try {
    localStorage.removeItem('user');
    await request.delete('/auth/sign_out');
  } catch (e) {
    console.error(e);
  }
}

export function checkEmail(payload: { email: string }) {
  return request.post<void, { emailTaken: boolean; name?: string }>('/auth/sign_up/check_email', payload);
}

export function employerSignUp(payload) {
  return request.post('/auth/sign_up/candidate', payload);
}

export function candidateSignUp(payload) {
  return request.post('/auth/sign_up/candidate', payload);
}

export function resetPassword(payload: { token: string; password: string; passwordConfirm: string }) {
  return request.post('/auth/password/reset', payload);
}
